import { render, staticRenderFns } from "./update-purpose.vue?vue&type=template&id=14461c1c"
import script from "./update-purpose.vue?vue&type=script&lang=js"
export * from "./update-purpose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14461c1c')) {
      api.createRecord('14461c1c', component.options)
    } else {
      api.reload('14461c1c', component.options)
    }
    module.hot.accept("./update-purpose.vue?vue&type=template&id=14461c1c", function () {
      api.rerender('14461c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rule-engine/data-purpose/update-purpose.vue"
export default component.exports